import FAApi from './_faApi.js';
import httpClient from '@/apis/base/httpclient';
class QltsVoucherAPI extends FAApi {
  constructor() {
    super();
  }
  controllerName = 'QltsVouchers';
  /**
   * Gọi API lấy dữ liệu từ QLTS
   * TVDAT 14/09/2022
   */
  getDataQlts(param) {
    let request = {
      url: this.getAPIUrl() + `/DataConnectingFixedAsset`,
      data: param
    };

    return httpClient.postAsync(request);
  }
  /**
   * Gọi API lấy dữ liệu đồng bộ danh mục giữa QLTS và MimosaOnline
   * TVDAT 11/03/2023
   */
  getDataSyncCategory(param) {
    let request = {
      url: this.getAPIUrl() + `/SyncCategory`,
      data: param
    };
    return httpClient.postAsync(request);
  }
  /**
   * Gọi API Sinh chứng từ
   * TVDAT 07/09/2022
   */
  generateVoucherQlts(param) {
    let request = {
      url: this.getAPIUrl() + `/DataQLTS?refType=${param.refType}`,
      data: param.assetList
    };

    return httpClient.postAsync(request);
  }
  /**
   * Gọi API map nguồn
   * TVDAT 09/09/2022
   */
  mappingBudgetSourceQlts() {
    let request = {
      url: this.getAPIUrl() + '/MapQlts'
    };
    return httpClient.postAsync(request);
  }
  /**
   * Lưu chứng từ
   * NBTIN 13/09/2022
   */
  async saveQltsVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + `/PostQLTS?refType=${payload.refType}`,
      data: payload.data
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Update mapping nguồn
   * TVDAT 09/09/2022
   */
  updateMappingBudgetSourceQlts(param) {
    let request = {
      url: this.getAPIUrl() + '/UpdateMapQlts/',
      data: param
    };

    return httpClient.putAsync(request);
  }
  /**
   * Lấy dữ liệu tài khoản chi tiết nhất theo refType
   * NBTIN 14/09/2022
   */
  getDataForGenerateVoucher() {
    let request = {
      url: this.getAPIUrl() + `/GetDataForGenerateVoucher`
    };

    return httpClient.getAsync(request);
  }
  /**
   * Kết nối QLTS
   * NXCHIEN 14/09/2022
   */
  connectQLTS() {
    let request = {
      url: this.getAPIUrl() + '/ConnectingFixedAsset'
    };

    return httpClient.getAsync(request);
  }

  /**
   * Sinh dòng hạch toán chi tiết chứng từ
   * ntloc 24/5/2024
   */
  generateVoucherDetailQlts(param) {
    let request = {
      url: this.getAPIUrl() + `/DataDetailQLTS?refType=${param.refType}`,
      data: param.assetList
    };

    return httpClient.postAsync(request);
  }

  /**
   * Gọi api lấy dữ liệu qlts theo mã tài sản
   * ntloc 24/5/2024
   */
  getDataDetailQlts(param) {
    let request = {
      url: this.getAPIUrl() + `/DataConnectingFixedAssetByFaHistoyIds`,
      data: param
    };

    return httpClient.postAsync(request);
  }
}
export default new QltsVoucherAPI();
